import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  FormHelperText,
} from "@material-ui/core";
import Notification from "../../components/Notification/Notification";
import { useDispatch, useSelector } from "react-redux";
import { addExpense, getBookingInvoice } from "../../store/action";
import { notificationSuccess } from "../../store/action/notificationMsg";
import moment from "moment";

const useStyle = makeStyles((theme) => ({
  dialogWidth: { width: "100%" },
}));

const AddExpense = ({ open, handleClose, bookingRef, bookingCandidate , type, candidateId,setActiveTab,tempId,getTempTimesheetDetail,nextId,resetCheckboxes,getBookingList,page,searchData,order,firstDayOfWeek,lastDayOfWeek,orderBy,setBookingId,setBookingRef, resetBooking}) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [roleMsg, setRoleMsg] = useState(false);
  const { holidayErrors, holidaySuccess } = useSelector((state) => state.holiday);
  const [formError, setError] = useState([]);

  const initialData = {
    amount_charged: "",
    amount_paid: "",
    charge_rate: "",
    expense_unit: "",
    pay_rate: "",
    expense_type: "",
    candidate_id: candidateId || "",
    comment: "",
    type: type || "",
    bookingCandidate: bookingCandidate || "",
  };

  const [data, setData] = useState(initialData);

  const expenseType = [
    {id:'Mileage' ,name:'Mileage'},
    {id:'Accommodation' ,name:'Accommodation'},
    {id:'Nights/Saturdays' ,name:'Nights/Saturdays'},
    {id:'Days' ,name:'Days'},
    {id:'Sundays/Bank Holidays' ,name:'Sundays/Bank Holidays'},
    {id:'Referral' ,name:'Referral'},
    {id:'Parking' ,name:'Parking'},
    {id:'Others' ,name:'Others'},
  ];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
      bookingCandidate: bookingCandidate || "",
      candidate_id: candidateId || "",
      type: type || "",
    }));
  };

  const handleChangeExpenseUnit = (event) => {
    const expenseUnit = parseFloat(event.target.value) || 0;
    const amountPaid = expenseUnit * (parseFloat(data.pay_rate) || 0);
    const amountCharged = expenseUnit * (parseFloat(data.charge_rate) || 0);
    setData((prev) => ({
      ...prev,
      expense_unit: event.target.value,
      amount_paid: amountPaid.toFixed(2),
      amount_charged: amountCharged.toFixed(2),
    }));
  };

  const handleChangePayrate = (event) =>{
    const payRate = parseFloat(event.target.value) || 0;
    const amountPaid = (parseFloat(data.expense_unit) || 0) * payRate;
       setData(prevData => ({
      ...prevData,
        pay_rate: payRate, 
        amount_paid: amountPaid.toFixed(2), 
      }));
  }

  const handleChangeChargerate = (event) =>{
    const chargeRate = parseFloat(event.target.value) || 0;
    const amountCharged = (parseFloat(data.expense_unit) || 0) * chargeRate;
    setData((prev) => ({
      ...prev,
      charge_rate: event.target.value,
      amount_charged: amountCharged.toFixed(2),
    }));
  }

   const validateFields = () => {
    const requiredFields = [
      { key: "expense_type", error: "err_expense_type" },
      { key: "expense_unit", error: "err_expense_unit" },
      { key: "pay_rate", error: "err_pay_rate" },
      { key: "charge_rate", error: "err_charge_rate" },
      { key: "amount_paid", error: "err_amount_paid" },
      { key: "amount_charged", error: "err_amount_charged" },
    ];

    for (let field of requiredFields) {
      if (!data[field.key] || data[field.key] === "") {
        setError(field.error);
        return false;
      }
    }
    return true;
  };

  const onSubmitExpense = async (event) => {
    event.preventDefault();
    if (!validateFields()) return;

    dispatch(addExpense({...data, tempId}))
    resetBooking();
    setRoleMsg(true);
    handleClose();
    setData(initialData);
    setActiveTab?.("EXPENSES");

    const hasBookingRef = bookingRef?.length > 0;

    if (hasBookingRef) {
      getTempTimesheetDetail?.(nextId, "null");

      getBookingList?.(
        page,
        searchData.search,
        "PROVISIONAL",
        searchData?.specialty,
        searchData?.customer,
        searchData?.site,
        searchData?.ward,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date ? moment(searchData.start_date).format("DD-MM-yyyy") : firstDayOfWeek,
        searchData?.end_date ? moment(searchData.end_date).format("DD-MM-yyyy") : lastDayOfWeek,
        searchData?.provisional_status,
        order,
        orderBy
      );
      
      resetCheckboxes?.();
      setBookingId?.([]);
      setBookingRef?.([]);
    }
    
  };

  const closeModal = () => {
    setError([]);
    setData(initialData);
    handleClose();
  };

  const bookingReference = bookingRef?.join(", ");

  return (
    <>
      {roleMsg && holidayErrors?.message && (
        <Notification data={holidayErrors?.message} status="error" />
      )}
      {roleMsg && holidaySuccess?.message && (
        <Notification data={holidaySuccess?.message} status="success" />
      )}
      <Dialog open={open} onClose={closeModal} classes={{ paper: classes.dialogWidth }}>
        <form onSubmit={(event) => onSubmitExpense(event)}>
          <DialogTitle id="form-dialog-title">
            <Typography variant="h6">Add Expense</Typography>
          </DialogTitle>

          <Divider />

          <DialogContent>
            {bookingReference && (
              <Typography variant="body1" style={{ marginBottom: 16 }}>
                You have selected Booking Ref No.{" "}
                <span style={{ color: "secondary", fontWeight: 600 }}>
                  {bookingReference}
                </span>
              </Typography>
            )}

            <Grid container spacing={3}>
              {/* Expense Type */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth variant="outlined" error={formError.includes("err_expense_type") ? true : false}>
                  <InputLabel id="select-label">Expense Type</InputLabel>
                  <Select value={data.expense_type} label="Expense Type" name="expense_type" onChange={handleChange}>
                    {expenseType?.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {formError.includes("err_expense_type") && (
                    <FormHelperText>Please select an expense type</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Expense Unit */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  id="expense_unit"
                  label="Expense Unit"
                  variant="outlined"
                  name="expense_unit"
                  fullWidth
                  required
                  value={data.expense_unit || ""}
                  error={formError.includes("err_expense_unit")}
                  helperText={formError.includes("err_expense_unit") ? "Please enter expense unit" : ""}
                  onChange={handleChangeExpenseUnit}
                />
              </Grid>

              {/* Pay Rate */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  id="pay_rate"
                  label="Pay Rate"
                  variant="outlined"
                  name="pay_rate"
                  fullWidth
                  required
                  value={data.pay_rate || ""}
                  error={formError.includes("err_pay_rate")}
                  helperText={
                    formError.includes("err_pay_rate") ? "Please enter pay rate" : ""
                  }
                  onChange={handleChangePayrate}
                />
              </Grid>

              {/* Amount Paid */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  id="amount_paid"
                  label="Amount Paid"
                  variant="outlined"
                  name="amount_paid"
                  fullWidth
                  value={data.amount_paid || ""}
                  disabled
                  onChange={handleChange}
                />
              </Grid>

              {/* Charge Rate */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  id="charge_rate"
                  label="Charge Rate"
                  variant="outlined"
                  name="charge_rate"
                  fullWidth
                  required
                  value={data.charge_rate || ""}
                  error={formError.includes("err_charge_rate")}
                  helperText={
                    formError.includes("err_charge_rate") ? "Please enter charge rate" : ""
                  }
                  onChange={handleChangeChargerate}
                />
              </Grid>

              {/* Amount Charged */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  id="amount_charged"
                  label="Amount Charged"
                  variant="outlined"
                  name="amount_charged"
                  fullWidth
                  value={data.amount_charged || ""}
                  disabled
                  onChange={handleChange}
                />
              </Grid>

              {/* Comment */}
              <Grid item xs={12}>
                <TextField
                  id="comment"
                  label="Comment"
                  variant="outlined"
                  name="comment"
                  fullWidth
                  multiline
                  rows={3}
                  value={data.comment || ""}
                  onChange={handleChange}
                />
              </Grid>

            </Grid>
          </DialogContent>

          <DialogActions className="pr-4 pb-2">
            <Button onClick={closeModal} color="primary">Cancel</Button>
            <Button color="secondary" variant="contained" type="submit">
              { bookingReference ? 'Add and Link':'Add'}

            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default AddExpense;
